/** Courier rate: 1.25 JOD first km, then 0.25 JOD per extra km. A 3 km trip is 1.75 JOD. */

const FIRST_KM_JOD = Number(process.env.REACT_APP_DELIVERY_FEE_FIRST_KM_JOD || 1.25);
const EXTRA_KM_JOD = Number(process.env.REACT_APP_DELIVERY_FEE_EXTRA_KM_JOD || 0.25);

function round2(n: number): number {
  return Math.round(Number(n || 0) * 100) / 100;
}

export function deliveryFeeJod(distanceKm?: number | null): number {
  if (distanceKm == null) return 0;
  const km = Number(distanceKm);
  if (!Number.isFinite(km) || km < 0) return 0;
  return round2(FIRST_KM_JOD + EXTRA_KM_JOD * Math.max(0, km - 1));
}
